import { React } from '../../libraries';
const CustomSpan = ({ text, color, className }) => {
  return (
    <span style={{ color }} className={className}>
      {text}
    </span>
  );
};
export default CustomSpan;